import React from "react";
import { Col, Space } from "antd";

import NoticeList from "../../components/NoticeList";

function TextNotice() {
    return (
        <div className="container">
            <Space size={30} direction="vertical" style={{ width: "100%" }}>
                <h3 className="title">문자 안내 공지</h3>
                <NoticeList />
            </Space>
        </div>
    );
}

export default TextNotice;
